import styled from 'styled-components';
import { POPOVER_WRAPPER_PADDING } from './consts';
import { colors, s8, shadowM } from '@ardoq/design-tokens';

export const PopoverWrapper = styled.div`
  background: ${colors.surfaceDefault};
  box-shadow: ${shadowM};
  border-radius: ${s8};
  padding: ${POPOVER_WRAPPER_PADDING}px;
  overflow-wrap: break-word;
`;

export const PopoverSection = styled.div`
  margin-top: 16px;
`;
